import React from "react";
import Reveal from "../components/Reveal";

const Legal = ({ title, tag, sections }) => (
  <div className="pt-32 pb-24 max-w-3xl mx-auto px-5 sm:px-8 min-h-screen">
    <Reveal>
      <div className="label-caps mb-3">{tag}</div>
      <h1 className="font-display text-5xl sm:text-6xl tracking-tighter mb-10">{title}</h1>
    </Reveal>
    <div className="space-y-8 text-gray-400 leading-relaxed">
      {sections.map(([h, body], i) => (
        <Reveal key={i} delay={i * 0.04}>
          <h2 className="font-display text-2xl text-white mb-2">{h}</h2>
          <p>{body}</p>
        </Reveal>
      ))}
    </div>
  </div>
);

export function Privacy() {
  return (
    <div data-testid="privacy-page">
      <Legal
        title="Privacy Policy"
        tag="Your data"
        sections={[
          ["What we collect", "We collect your name, email and phone number when you register or book an appointment. This information is used solely to manage your bookings and keep you informed about your visits."],
          ["How we use it", "Your details are used to confirm appointments, send booking notifications and improve your experience with Who's Next Barber Shop. We never sell your data."],
          ["Cookies & storage", "We store a secure sign-in token in your browser to keep you logged in. No third-party advertising cookies are used."],
          ["Your rights", "You can request access to, correction of, or deletion of your personal data at any time by contacting the shop directly."],
          ["Contact", "For any privacy queries, reach us at 109 Plungington Road, Preston, PR1 7UE or call 07876 746744."],
        ]}
      />
    </div>
  );
}

export function Terms() {
  return (
    <div data-testid="terms-page">
      <Legal
        title="Terms of Service"
        tag="The fine print"
        sections={[
          ["Bookings", "By booking through our website you agree to arrive on time for your appointment. Please allow a few minutes for consultation."],
          ["Cancellations", "Appointments cannot be cancelled through the website. If you're unable to attend, please contact the shop directly by phone or WhatsApp as early as possible."],
          ["Payments", "We do not take online payments. All payments are made in-shop upon completion of your service."],
          ["Late arrivals", "If you arrive late, we'll do our best to accommodate you, but your service may be shortened or rescheduled to respect other clients."],
          ["Conduct", "We maintain a welcoming, respectful environment. We reserve the right to refuse service to anyone behaving inappropriately."],
        ]}
      />
    </div>
  );
}

export default Privacy;
